import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'add-remark-popup',
  templateUrl: './add-remark-popup.component.html',
  styleUrls: ['./add-remark-popup.component.scss'],
})
export class AddRemarkPopup implements OnInit {

  @Input() remarkOptional = false;
  @Input() dialogTitle = 'Order Status Remark';
  @Input() fieldLabel = 'Reason';
  @Input() useTextarea = false;
  @Input() set numericOnly(val: boolean) {
    this._numericOnly = val;
    if (this.form && val) {
      this.form.get('remark').setValidators([
        Validators.required,
        Validators.min(1),
        Validators.pattern(/^[0-9]*$/),
      ]);
      this.form.get('remark').updateValueAndValidity();
    }
  }
  get numericOnly(): boolean {
    return this._numericOnly;
  }

  form: FormGroup;
  private _numericOnly = false;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddRemarkPopup>,
  ) {
  }

  ngOnInit(): void {
    this.form = this.initializeForm();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (!this.remarkOptional && this.form.invalid) {
      return;
    }

    const remark = this.form.controls.remark.value;
    this.dialogRef.close(remark ?? '');
  }

  initializeForm(): FormGroup {
    const validators = this.remarkOptional ? [] : [Validators.required];
    if (this._numericOnly) {
      validators.push(Validators.min(1), Validators.pattern(/^[0-9]*$/));
    }
    return this.formBuilder.group({
      remark: [null, validators],
    });
  }
}
